import * as React from "react";
import { forwardRef } from "react";
const SvgHamburgerSlim = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 15 8", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", { id: "Layer_1" }, /* @__PURE__ */ React.createElement("path", { d: "M.4.4h14.2v.8H.4V.4ZM.4,6h14.2v.8H.4v-.8Z" }))));
const ForwardRef = forwardRef(SvgHamburgerSlim);
export { ForwardRef as ReactComponent };
